import { resourceListInit } from '../components/search/resourceList.js'

resourceListInit()